import "babel-polyfill";
import vuetify from "./plugins/vuetify";
import Vuetify from "vuetify/lib";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // for popper.js
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueMapboxTs from "vue-mapbox-ts-legacy";
import Vue from "vue";
import VueLazyload from "vue-lazyload";

import { makeStore } from "./store";
import { prepareStorage, prepareServices } from "./plugins";

import App from "./App.vue";
import Meta from "vue-meta";
import { router } from "./router";
import i18n from "./i18n";
import filters from "./filters";

import "material-design-icons-iconfont/dist/material-design-icons.css";

const BACKEND_URL = "http://127.0.0.1:8120";
const apiURL =
  (process.env.NODE_ENV === "production" ? "" : BACKEND_URL) + "/api/v1";

Vue.config.productionTip = false;
export const store = makeStore();
prepareStorage(store);
prepareServices(store, apiURL);

Vue.use(Meta);
Vue.use(Vuetify);
Vue.use(BootstrapVue);
Vue.use(VueMapboxTs);
Vue.use(VueLazyload, {
  observer: true,
  lazyComponent: true,
});

for (let [name, filter] of Object.entries(filters)) {
  Vue.filter(name, filter);
}

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h): Vue.VNode => h(App),
}).$mount("#app");
